const PolitiqueConfidentialitePage = () => (
  <div className="bg-white">
    <div className="container mx-auto px-4 py-12 md:py-20">
      <div className="max-w-3xl mx-auto text-gray-800">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Politique de confidentialité
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          <strong>Dernière mise à jour : 27 avril 2026</strong>
        </p>

        <p className="text-base leading-relaxed mb-6">
          Le Groupe Scolaire Sanaa («&nbsp;GSS&nbsp;», «&nbsp;nous&nbsp;»), exploité par
          Institution&nbsp;Sanaa, accorde une importance
          particulière à la protection de la vie privée des familles qui visitent son site et
          de leurs enfants. La présente politique explique quelles données nous collectons,
          pourquoi, comment nous les utilisons et quels sont vos droits.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          1. Responsable du traitement
        </h2>
        <p className="text-base leading-relaxed mb-6">
          Institution Sanaa<br />
          <span className="text-gray-600">(exploitant le Groupe Scolaire Sanaa)</span><br />
          364 boulevard Oum Rabia, Oulfa, Casablanca, 20220, Maroc<br />
          Téléphone : <a href="tel:0522908238" className="underline hover:text-gray-600">0522908238</a><br />
          Email de contact : <a href="mailto:info@gssanaa.com" className="underline hover:text-gray-600">info@gssanaa.com</a>
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          2. Données que nous collectons
        </h2>
        <p className="text-base leading-relaxed mb-3">
          Nous collectons uniquement les données que vous nous communiquez volontairement via :
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>
            <strong>Formulaire RSVP Journée Portes Ouvertes</strong> : prénom de l’enfant,
            niveau scolaire (maternelle ou primaire), nom du parent, téléphone, email,
            paramètres de campagne (UTM).
          </li>
          <li>
            <strong>Formulaire de demande de visite</strong> : nom du parent, téléphone, email,
            quartier de résidence, niveau scolaire de l’enfant, nombre d’enfants, source de
            découverte, message libre.
          </li>
          <li>
            <strong>Données de navigation</strong> : pages visitées, durée, appareil et
            navigateur, source du trafic (cookies et pixels — voir §6).
          </li>
        </ul>
        <p className="text-base leading-relaxed mb-3">
          Nous <strong>ne collectons jamais</strong> : numéro de carte d’identité,
          données de santé, données bancaires, données politiques ou religieuses.
        </p>
        <p className="text-base leading-relaxed mb-6">
          Concernant les <strong>mineurs</strong> : les seules données collectées sur les
          enfants sont leur prénom et leur niveau scolaire, transmis par le parent dans le
          cadre de l’inscription ou du RSVP. Ces informations servent exclusivement à
          organiser l’accueil de l’enfant lors de la JPO ou la suite du dossier
          d’inscription.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          3. Finalités
        </h2>
        <p className="text-base leading-relaxed mb-3">Vos données sont utilisées pour :</p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>
            Organiser votre venue à la Journée Portes Ouvertes du 16 mai 2026 et préparer
            le test gratuit de votre enfant.
          </li>
          <li>
            Vous recontacter (téléphone ou email) pour confirmer votre rendez-vous,
            répondre à vos questions, ou poursuivre une démarche d’inscription que vous
            avez initiée.
          </li>
          <li>
            Mesurer l’efficacité de nos campagnes marketing (sans vous profiler
            individuellement à des fins publicitaires en dehors de Meta — voir §6).
          </li>
          <li>Améliorer la qualité de notre site et de nos services.</li>
        </ul>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          4. Durée de conservation
        </h2>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>Données RSVP JPO : conservées 12 mois après l’événement, puis supprimées.</li>
          <li>
            Données de demande de visite : conservées tant que la démarche est active, et
            24 mois après la dernière interaction si non aboutie. En cas d’inscription
            effective, les données rejoignent le dossier scolaire de l’élève (durée
            légale de conservation des dossiers scolaires).
          </li>
          <li>Logs techniques (navigation) : 13 mois maximum.</li>
        </ul>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          5. Partage de vos données
        </h2>
        <p className="text-base leading-relaxed mb-3">
          Vos données ne sont <strong>jamais vendues</strong>. Elles peuvent être partagées
          avec :
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>
            Les <strong>enseignants et personnel administratif</strong> de GSS, dans la
            stricte mesure nécessaire à l’organisation pédagogique ou administrative.
          </li>
          <li>
            Notre <strong>prestataire d’hébergement</strong> du site et de la base de
            données, soumis à un accord de confidentialité.
          </li>
          <li>
            Meta Platforms (Facebook, Instagram), uniquement pour les données de
            navigation et de conversion via le Pixel Meta — voir §6.
          </li>
        </ul>
        <p className="text-base leading-relaxed mb-6">
          Aucun transfert de données hors du Maroc n’est effectué autrement que dans le
          cadre des outils techniques mentionnés ci-dessus (hébergement, Pixel Meta).
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          6. Cookies et pixels publicitaires
        </h2>
        <p className="text-base leading-relaxed mb-3">Notre site utilise :</p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>
            <strong>Cookies fonctionnels</strong> (session, préférences) : nécessaires au
            bon fonctionnement, non désactivables.
          </li>
          <li>
            <strong>Pixel Meta (Facebook/Instagram)</strong> : un identifiant anonyme est
            associé à votre visite si vous avez un compte Meta. Il permet à GSS de mesurer
            l’efficacité de ses publicités et d’afficher des annonces pertinentes aux
            personnes intéressées par notre offre éducative. Vous pouvez gérer vos
            préférences publicitaires Meta directement dans les paramètres de votre
            compte Facebook ou Instagram.
          </li>
          <li>
            <strong>Outils d’analyse de trafic</strong> (le cas échéant : Google Analytics,
            PostHog) : agrégés et anonymisés.
          </li>
        </ul>
        <p className="text-base leading-relaxed mb-6">
          Vous pouvez à tout moment effacer ces cookies depuis les paramètres de votre
          navigateur.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          7. Vos droits
        </h2>
        <p className="text-base leading-relaxed mb-3">
          Conformément à la loi 09-08 relative à la protection des données personnelles
          au Maroc, vous disposez des droits suivants :
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li><strong>Accès</strong> à vos données.</li>
          <li><strong>Rectification</strong> des données inexactes.</li>
          <li><strong>Suppression</strong> de vos données.</li>
          <li><strong>Opposition</strong> au traitement à des fins marketing.</li>
          <li><strong>Limitation</strong> du traitement.</li>
        </ul>
        <p className="text-base leading-relaxed mb-6">
          Pour exercer ces droits, écrivez à{' '}
          <a href="mailto:info@gssanaa.com" className="underline hover:text-gray-600">info@gssanaa.com</a>{' '}
          ou par courrier à l’adresse du responsable du traitement (§1). Nous répondons
          sous 30 jours maximum.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          8. Sécurité
        </h2>
        <p className="text-base leading-relaxed mb-6">
          Les données sont stockées sur des serveurs sécurisés, accès restreint au
          personnel autorisé, mots de passe et sauvegardes régulières. En cas de violation
          de données, nous vous informons dans les 72 heures conformément aux obligations
          légales.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          9. Modifications de la politique
        </h2>
        <p className="text-base leading-relaxed mb-6">
          Cette politique peut évoluer. La date de dernière mise à jour figure en haut de
          la page. Toute modification importante sera notifiée par email aux personnes
          ayant un dossier actif.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3">
          10. Contact
        </h2>
        <p className="text-base leading-relaxed mb-3">
          Pour toute question relative à cette politique ou à vos données personnelles :
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>Email : <a href="mailto:info@gssanaa.com" className="underline hover:text-gray-600">info@gssanaa.com</a></li>
          <li>Téléphone : <a href="tel:0522908238" className="underline hover:text-gray-600">0522908238</a></li>
          <li>Adresse : 364 boulevard Oum Rabia, Oulfa, Casablanca, 20220</li>
        </ul>
      </div>
    </div>
  </div>
);

export default PolitiqueConfidentialitePage;
